export const defaultMenuType = 'menu-sub-hidden';

// define el número de filas de datos por páginas a mostrar en listas, tablas etc
export const filasPorPaginacion = 10;

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const decimales = 1000000;
export const defaultCloseWindows = 60000;
export const defaultLocale = 'es';
export const localeOptions = [
  { id: 'en', name: 'English - LTR', direction: 'ltr' },
  { id: 'es', name: 'Español', direction: 'ltr' },
  { id: 'enrtl', name: 'English - RTL', direction: 'rtl' },
];
export const defaultempresa = 'favia';
export const defaultempresakey = '__empresa';
export const firebaseConfig = {
  apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
  authDomain: 'gogo-react-login.firebaseapp.com',
  databaseURL: 'https://gogo-react-login.firebaseio.com',
  projectId: 'gogo-react-login',
  storageBucket: 'gogo-react-login.appspot.com',
  messagingSenderId: '216495999563',
};
export const FontZiseIcon = '1.3em';
export const IconsDefaults = {
  Editar: 'iconsminds-file-edit',
  Ver: 'simple-icon-book-open',
  Seleccionar: 'iconsminds-arrow-next',
  SubirArchivo: 'simple-icon-cloud-upload',
  EnviarMensaje: 'iconsminds-mail-send',
  EliminadoLogico: 'iconsminds-delete-file',
  Imprimir: 'iconsminds-printer',
  EliminadoFisico: 'simple-icon-trash',
  AgregarItem: 'iconsminds-add',
  Actualizar: 'iconsminds-synchronize-2',
  Descargar: 'simple-icon-cloud-download',
  NoActivoMensaje: 'iconsminds-mail-block',
  FormatoIncorrecto: 'iconsminds-arrow-x-left',
  Guardar: 'iconsminds-save',
  Ver2: 'simple-icon-eye',
  Buscar: 'simple-icon-magnifier',
  Sucursal: 'iconsminds-office',
  Servicio: 'iconsminds-affiliate',
  Producto: 'iconsminds-pantone',
  Categoria: 'iconsminds-bookmark',
  Especialidad: 'iconsminds-medical-sign',
  Calendario: 'simple-icon-calendar',
  Empleado: 'iconsminds-user',
  Usuario: 'simple-icon-people',
  Identificacion: 'iconsminds-id-card',
  Proyecto: 'iconsminds-project',
  CollapseCerrar: 'iconsminds-arrow-up',
  CollapseAbrir: 'iconsminds-arrow-down',
  Detalle: 'iconsminds-arrow-inside',
  Mapa: 'iconsminds-map2',
  Telefono: 'simple-icon-screen-smartphone',
};

export const idRoot = 'b7cfa5f1-04d8-4c41-8c7a-9ae5d34fd861';
export const idNotaCredito = '68472de2-82b2-11eb-ab82-525400e56054';
export const idFactura = '34abd046-82b2-11eb-ab82-525400e56054';

export const urlQr =
  'https://chart.googleapis.com/chart?chs=64x64&cht=qr&chl={1}&choe=UTF-8';

export const adminRoot = '/app';
export const searchPath = `${adminRoot}/#`;
export const servicePath = 'https://api.coloredstrategies.com';

export const pageSizes = [5, 10, 15, 20, 25];

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = true;
export const defaultColor = 'light.purplemonster';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';

export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];

export const Grupo = {
  Categoria: 'a146eaae-60bd-11eb-8430-0242ac120003',
  TagProductos: 'cd2892fc-7180-11eb-986b-0242ac120003',
  Unidades: 'b29bbe70-7183-11eb-986b-0242ac120003',
  TipoConsulta: '6e568a50-73d7-11eb-90f3-0242ac120003',
  EstadoAgenda: 'a7b9a8c6-7478-11eb-8f8e-0242ac120003',
  TipoIdentificacion: 'd77a9029-4629-4431-875a-2d839f9a1542',
  Sexo: '50c05492-244c-4536-822f-0285281ea963',
  EstadoCivil: '2217dc45-fd28-4126-9ba1-99b252a69730',
  TipoSeguro: 'a56126d8-2ce2-11e9-80db-525400e56054',
  Parentesco: '20c16222-2d40-11e9-91ad-525400e56054',
  TipoComprobante: 'c062c988-82b1-11eb-b6aa-525400e56054',
  TipoEmision: 'f5f48aa6-836e-11eb-843a-525400e56054',
  CodigoDerivacion: '79db0f36-2d98-11e9-949d-525400e56054',
  ContingenciCubierta: '6f47f440-2d42-11e9-91ad-525400e56054',
  TipoAmbiente: 'ce3b60aa-82b2-11eb-b6aa-525400e56054',
  TipoContribuyente: 'f53b9d7a-876a-11eb-8bf8-525400e56054',
  TipoDocumento: '39bb946e-96e8-11eb-b8ab-525400e56054',
  TipoPago: '12fe108e-663e-11eb-9537-0242ac120003',
  FormaPago: 'f42b15de-b995-11eb-97ca-525400e56054',
  IVA: 'fe94af2c-b9b2-11eb-8cc4-525400e56054',
  TipoComprobanteEmpresa: 'd02485a2-ad61-11eb-b556-525400e56054',
  Bancos: 'b13f4012-bcef-11eb-a64b-c869cdb23ff0',
  TarjetaCredito: '140b2286-e8e4-11eb-9e74-525400e56054',
  Moneda: 'd19237aa-c4ad-11eb-88aa-525400e56054',
  Especialidades: '106ad5d2-d526-11e9-b446-525400e56054',
  NivelEmergencia: '42102cca-06a4-11ec-8746-525400e56054',
  Impuestos: 'ab7e6a64-105e-11ec-864d-0242ac120004',
  TipoCuenta: '920692b2-addc-11eb-8488-525400e56054',
  PruebasLaboratorio: '56287ea8-2f83-11ec-a4ec-525400e56054',
  TipoCuentaBanco: '1277b174-53c3-11ec-944e-525400e56054',
  Documentos: 'f011a5de-8ab5-11ec-b55f-525400e56054',
  TipoServicioClinica: '0a21db0a-2cf5-11e9-80db-525400e56054',
};

export const GrupoDetalle = {
  TipoVehiculo: 'keyTipoVehiculo',
  Marca: 'keyMarca',
  Modelo: 'keyModelo',
  Diagrama: 'keyDiagrama',
  Funcion: 'keyFuncion',
  Servicios: 'KeyServicios',
  Especialidades: '5273484c-d526-11e9-a0df-525400e56054',
};

export const Ecuador = 1;
export const CajaActual = 'CajaActual';

export const keys = {
  keyRols: 'keyRols',
  keySistems: 'keySistems',
  keyActualEmpresa: 'keyActualEmpresa',
  keyProvincias: 'keyProvincias',
  keyCantones: 'keyCantones',
  keySucursales: 'keySucursales',
  keyCurrentEmpleado: 'keyCurrentEmpleado',
  keySoporte: 'KeySoporte',
  keyCanalComunicacion: 'keyCanalComunicacion',
  keyUnidadMedida: 'keyUnidadMedida',
  keyBodega: 'keyBodega',
  KeyCaterogiaProducto: 'KeyCaterogiaProducto',
  keyWhatsApp: 'keyWhatsApp',
  keyIspExepciones: 'keyIspExepciones',
  keyConsultorios: 'keyConsultorios',
  KeyCurrentPeriodo: 'KeyCurrentPeriodo',
  KeyPeriodos: 'KeyPeriodos',
  KeyCurrentConfigVenta: 'KeyCurrentConfigVenta',
  KeyLogoBase64: 'KeyLogoBase64',
  keyServicioLaboratorio: 'keyServicioLaboratorio',
  keyImagenes: 'keyImagenes',
  KeySegurosConvenio: 'KeySegurosConvenio',
  keyBancosEmpresa: 'keyBancosEmpresa',
  keyCurrentConfiguracion: 'keyCurrentConfiguracion',
  keyCurrentResponsableLaboratorio: 'keyCurrentResponsableLaboratorio',
  keyCurrentResponsableImagen: 'keyCurrentResponsableImagen',
  KeyCurrentMedico: 'KeyCurrentMedico',
  keyPrecios: 'keyPrecios',
  KeyServiciosMedicos: 'KeyServiciosMedicos',
  KeyMarcaProducto: 'KeyMarcaProducto',
};

export const estadosContratos = [
  { key: 'A', label: 'Activo', value: 'A' },
  { key: 'S', label: 'Suspendido', value: 'S' },
  { key: 'F', label: 'Finalizado', value: 'F' },
  { key: 'T', label: 'Todos', value: '' },
];

export const estadosAgenda = [
  { key: 'P', label: 'Pendiente', value: 'P' },
  { key: 'C', label: 'Confirmado', value: 'C' },
];

export const OjosLista = [
  { key: 'D', label: 'Derecho', value: 'D' },
  { key: 'I', label: 'Izquirdo', value: 'I' },
  { key: 'A', label: 'Derecho - Izquirdo', value: 'A' },
];

export const tipoDerivadoEmergencia = [
  { key: '1', label: 'Consola', value: '1' }, // al 911
  { key: '2', label: 'Sin consola', value: '2' },
];

export const Todos = {
  key: 'T',
  label: 'Todos',
  value: '',
};

export const TypeMessage = {
  None: 0,
  Success: 1,
  Warning: 2,
  Error: 3,
  Info: 4,
};
